// extracted by mini-css-extract-plugin
export default {"container":"ClientsStatementsFilter_container__3muyk","innerContainer":"ClientsStatementsFilter_innerContainer__0jotN","element":"ClientsStatementsFilter_element__QdCCF"};